export default __webpack_public_path__ + "static/media/img (1).4b4c56b2.jpg";